"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicWidgets = DynamicWidgets;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _useDynamicWidgets2 = require("../connectors/useDynamicWidgets");

var _invariant = require("../lib/invariant");

var _excluded = ["children", "fallbackComponent"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function FallbackComponent() {
  return null;
}

function DynamicWidgets(_ref) {
  var children = _ref.children,
      _ref$fallbackComponen = _ref.fallbackComponent,
      Fallback = _ref$fallbackComponen === void 0 ? FallbackComponent : _ref$fallbackComponen,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useDynamicWidgets = (0, _useDynamicWidgets2.useDynamicWidgets)(props, {
    $$widgetType: 'ais.dynamicWidgets'
  }),
      attributesToRender = _useDynamicWidgets.attributesToRender;

  var widgets = new Map();

  _react.default.Children.forEach(children, function (child) {
    var attribute = getWidgetAttribute(child);
    (0, _invariant.invariant)(attribute !== undefined, "<DynamicWidgets> only supports InstantSearch widgets with an `attribute` or `attributes` prop.");
    widgets.set(attribute, child);
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, attributesToRender.map(function (attribute) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: attribute
    }, widgets.get(attribute) || /*#__PURE__*/_react.default.createElement(Fallback, {
      attribute: attribute
    }));
  }));
}

function isReactElement(element) {
  return (0, _typeof2.default)(element) === 'object' && element.props;
}

function getWidgetAttribute(element) {
  if (!isReactElement(element)) {
    return undefined;
  }

  if (element.props.attribute) {
    return element.props.attribute;
  }

  if (Array.isArray(element.props.attributes)) {
    return element.props.attributes[0];
  }

  if (element.props.children) {
    (0, _invariant.invariant)(_react.default.Children.count(element.props.children) === 1, "<DynamicWidgets> only supports a single component in nested components. Make sure to not render multiple children in a parent component.\n\nExample of an unsupported scenario:\n\n```\n<DynamicWidgets>\n  <MyComponent>\n    <RefinementList attribute=\"brand\" />\n    <Menu attribute=\"categories\" />\n  </MyComponent>\n</DynamicWidgets>\n```\n");
    return getWidgetAttribute(_react.default.Children.only(element.props.children));
  }

  return undefined;
}